import { render, staticRenderFns } from "./ItemProduct.vue?vue&type=template&id=79f72d40&"
import script from "./ItemProduct.vue?vue&type=script&lang=js&"
export * from "./ItemProduct.vue?vue&type=script&lang=js&"
import style0 from "./ItemProduct.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports